import { render, staticRenderFns } from "./lecturer.vue?vue&type=template&id=34628e35&scoped=true"
import script from "./lecturer.vue?vue&type=script&lang=js"
export * from "./lecturer.vue?vue&type=script&lang=js"
import style0 from "./lecturer.vue?vue&type=style&index=0&id=34628e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34628e35",
  null
  
)

export default component.exports